import * as _postcss3 from "postcss";
var _postcss2 = _postcss3;
try {
  if ("default" in _postcss3) _postcss2 = _postcss3.default;
} catch (e) {}
import * as _postcssNested2 from "postcss-nested";
var _postcssNested = _postcssNested2;
try {
  if ("default" in _postcssNested2) _postcssNested = _postcssNested2.default;
} catch (e) {}
import * as _postcssJs2 from "postcss-js";
var _postcssJs = _postcssJs2;
try {
  if ("default" in _postcssJs2) _postcssJs = _postcssJs2.default;
} catch (e) {}
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function () {
      return parseObjectStyles;
    }
  });
  const _postcss = /*#__PURE__*/_interop_require_default(_postcss2);
  const _postcssnested = /*#__PURE__*/_interop_require_default(_postcssNested);
  const _postcssjs = /*#__PURE__*/_interop_require_default(_postcssJs);
  function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function parseObjectStyles(styles) {
    if (!Array.isArray(styles)) {
      return parseObjectStyles([styles]);
    }
    return styles.flatMap(style => {
      return (0, _postcss.default)([(0, _postcssnested.default)({
        bubble: ["screen"]
      })]).process(style, {
        parser: _postcssjs.default
      }).root.nodes;
    });
  }
  return exports;
}